import React from 'react';

import LinkButton from '@atlaskit/button/link';

const LinkButtonSubtleExample = (): React.JSX.Element => {
	return (
		<LinkButton appearance="subtle" href="https://atlassian.com/">
			Subtle link button
		</LinkButton>
	);
};

export default LinkButtonSubtleExample;
